function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "BG",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67639",
  "data-name": "Group 67639",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_145",
  "data-name": "Group 145"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_141",
  "data-name": "Group 141"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1",
  "data-name": "Rounded Rectangle 1",
  d: "M30.4,221h3.2a2.4,2.4,0,0,1,2.4,2.4v11.2a2.4,2.4,0,0,1-2.4,2.4H30.4Zm0,1.6h3.2a.8.8,0,0,1,.8.8v11.2a.8.8,0,0,1-.8.8H30.4Zm0-1.6a.8.8,0,1,1-.8.8A.8.8,0,0,1,30.4,221Zm0,14.4a.8.8,0,1,1-.8.8A.8.8,0,0,1,30.4,235.4Zm-8-14.4h3.2a2.4,2.4,0,0,1,2.4,2.4v11.2a2.4,2.4,0,0,1-2.4,2.4H22.4a2.4,2.4,0,0,1-2.4-2.4V223.4a2.4,2.4,0,0,1,2.4-2.4Zm0,1.6h3.2a.8.8,0,0,1,.8.8V225a.8.8,0,0,1-.8.8H22.4a.8.8,0,0,1-.8-.8v-1.6A.8.8,0,0,1,22.4,222.6Zm0,4.8h3.2a.8.8,0,0,1,.8.8v6.4a.8.8,0,0,1-.8.8H22.4a.8.8,0,0,1-.8-.8v-6.4A.8.8,0,0,1,22.4,227.4Z",
  transform: "translate(-20 -221)",
  fill: "#7e84a3",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_201",
  "data-name": "Path 201",
  d: "M13.6,16H10.4a.8.8,0,1,1,0-1.6h3.2a.8.8,0,0,0,.8-.8V2.4a.8.8,0,0,0-.8-.8H10.4a.8.8,0,1,1,0-1.6h3.2A2.4,2.4,0,0,1,16,2.4V13.6A2.4,2.4,0,0,1,13.6,16Zm-8,0H2.4A2.4,2.4,0,0,1,0,13.6V2.4A2.4,2.4,0,0,1,2.4,0H5.6A2.4,2.4,0,0,1,8,2.4V13.6A2.4,2.4,0,0,1,5.6,16ZM6.4,2.4a.8.8,0,0,0-.8-.8H2.4a.8.8,0,0,0-.8.8V4a.8.8,0,0,0,.8.8H5.6A.8.8,0,0,0,6.4,4Zm0,4.8a.8.8,0,0,0-.8-.8H2.4a.8.8,0,0,0-.8.8v6.4a.8.8,0,0,0,.8.8H5.6a.8.8,0,0,0,.8-.8Z",
  fill: "#7e84a3",
  fillRule: "evenodd"
})));

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboardIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.aa635108.svg";
export { ForwardRef as ReactComponent };